export const belongsTo = [
    {belong: 'Patient' },
    {belong: 'Father' },
    {belong: 'Mother' },
    {belong: 'Son' },
    {belong: 'Daugther' },
    {belong: 'Grandfather' },
    {belong: 'Grandmother' },
    {belong: 'Other' }
];